/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-events',
    'pip-model',
    'window'
],
function(
    pipEvents,
    pip,
    window
){

	function initEventListeners(){
		pipEvents.fbt.fbtLinkClicked.on('.fbtLinkClicked', function(evtType, data){
			if(window.digitalData && window.digitalData.event) {
                window.digitalData.event.push({
                    category: {
                        primaryCategory: "stash"
                    },
                    eventInfo: {
                        eventName: "recommendation pip load"
                    },
                    eventMode: "stash",
                    stash: {
                        recommendation: {
                            recommendationType: "fbt",
                            pageType: "pip",
                            displayPosition: data.displayPosition,
                            anchorProductSku: data.anchorProductSku,
                            strategy: "n/a",
                            recommendationVersion: 'n/a',
                            featureVersion: 'n/a',
                            interval: "n/a",
                        }
                    }
                });
	
				if(pip.debugMode){
					window.location = data.href + window.location.search;
				} else {
					window.location = data.href;
				}			
			}
			
		});

	}

	return {
		init: function(){
			initEventListeners();
		},
	}

});

}.call(window));